import { type ListingLocationProps } from '@/services/types/listings/mockListings'
import { type StoreLocation } from '@/services/types/mockStoreLocations'
import { formatShortAddressWithLocationName } from '../addresses/formatShortAddressWithLocationName'

export function filterByLocationTitleAndAddress(
  input: string,
  location: StoreLocation | ListingLocationProps,
) {
  const { locationName, shortAddress } = formatShortAddressWithLocationName(location)

  const txt = input.toLowerCase()
  const match = `${locationName} ${shortAddress}`.toLowerCase().includes(txt)

  return match
}
